import { useBusinessContext } from '@root/context'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { fetchBusinessInvoicingCountries } from '../constants'

export const useBusinessInvoicingCountries = () => {
  const { slug } = useBusinessContext()

  return useQuery({
    queryKey: [slug, 'businessInvoicingCountries'],
    queryFn: () => fetchBusinessInvoicingCountries({ slug }),
    ...{
      enabled: Boolean(slug),
      placeholderData: keepPreviousData,
      staleTime: 6 * 60 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false
    }
  })
}
